














































































































































































































































































    import { Component, Vue } from 'vue-property-decorator'
	import * as Reveal from '@/assets/scripts/RevealOnScrollModule'
	import * as Accordion from '@/assets/scripts/AccordionModule'

    @Component
    export default class AccordionPage extends Vue {

        data() {
            return {
                PageTitle: "Accordion"
            }
        }
        mounted() {
            new Reveal.revealOnScrollModule()
            new Accordion.accordionModule()
        }
    }
